export function AchievementsScreen() {
  return (
    <div
      className="flex-1 overflow-y-auto pb-24 px-4 pt-4"
      style={{ paddingTop: 'calc(env(safe-area-inset-top) + 1rem)' }}
    >
      <h1 className="font-display text-2xl text-white">Достижения</h1>
      <div className="mt-12 text-center text-white/40">
        <div className="text-5xl mb-3">🏆</div>
        <div>В разработке…</div>
      </div>
    </div>
  );
}
